import { handleApiError } from '@/handleApiError'
import api from '@/modules/portalSettings/api'
import { DEFAULT_COMMENT_LENGTH } from '@/types'
import { OrderingConditions } from '@/types/index'
import { defineStore } from 'pinia'

export interface OrderingConditionsState {
  orderingConditions: OrderingConditions
  loading: boolean
}

const initialState = (): OrderingConditionsState => {
  return {
    orderingConditions: {
      showCustomerOrderId: false,
      customerOrderIdRequired: false,
      isPartialShipmentEnabled: false,
      maxCommentLength: DEFAULT_COMMENT_LENGTH,
      isSofortPaymentEnabled: false
    },
    loading: false
  }
}

const useOrderingConditions = defineStore('orderingConditions', {
  state: () => initialState(),
  actions: {
    async getOrderingConditions() {
      this.loading = true

      return api
        .getOrderingConditions()
        .then(({ data }) => {
          this.orderingConditions = data
        })
        .catch(handleApiError)
        .finally(() => {
          this.loading = false
        })
    }
  }
})

export default useOrderingConditions
